import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';


@Pipe({
  name: 'convertDatetime'
})
export class ConvertDatetimePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return this.convertDateTime(value);
  }
  convertDateTime(datetime: any): any {
 
    if (localStorage.getItem('clientTimeZone') !== null && localStorage.getItem('clientTimeZone') !== 'undefined'
      && localStorage.getItem('clientTimeZone') !== 'null') {
      let timezone = localStorage.getItem('clientTimeZone') || 'UTC';
      let date = moment(datetime).tz(timezone).format();
      let zone = moment.tz(datetime, timezone ).format('zz');
     
      
      let newDate = date.split('T');
      let splitedDate = newDate[0] + ' ' + newDate[1].substring(0, 8);
     
      return splitedDate + ' ' + '(' + zone + ')';
    } else {
      let zone = moment.tz(datetime, moment.tz.guess()).format('zz');
    // console.log("here2");
      return moment(datetime).format('YYYY-MM-DD H:mm:ss') + ' ' + '(' + zone + ')';
    }
  }


  convertGraphDateTime(datetime: any): any {
    if (localStorage.getItem('clientTimeZone') !== null && localStorage.getItem('clientTimeZone') !== 'undefined'
      && localStorage.getItem('clientTimeZone') !== 'null') {
        let clientTimeZone = localStorage.getItem('clientTimeZone') || 'UTC';
      let date = moment(datetime).tz(clientTimeZone).format();
      let zone = moment.tz(datetime, clientTimeZone).format('zz');
      let newDate = date.split('T');
      let splitedDate = newDate[0] + ' ' + newDate[1].substring(0, 8);
      return splitedDate + ' ' + '(' + zone + ')';
    } else {
      let zone = moment.tz(datetime, moment.tz.guess()).format('zz');
      return moment(datetime).format('YYYY-MM-DD H:mm:ss') + ' ' + '(' + zone + ')';
    }
  }

}
